<footer class="site-footer">
  <div class="footer-main">
    <div class="container" style="max-width: 1200px">
      <div class="row g-4">
        <!-- Brand Column -->
        <div class="col-lg-4 col-md-6">
          <div class="footer-brand">
            <img src="assets/images/horseloop-logo.png" alt="HorseLoop" class="footer-logo" />
            <p class="footer-tagline">{{ 'footer.tagline' | translate }}</p>
            <div class="footer-social">
              <a href="https://www.facebook.com/profile.php?id=61586708110985" target="_blank" aria-label="Facebook">
                <i class="fa-brands fa-facebook-f"></i>
              </a>
              <a href="https://www.instagram.com/horseloop.no/" target="_blank" aria-label="Instagram">
                <i class="fa-brands fa-instagram"></i>
              </a>
              <a href="https://www.tiktok.com/@horseloop" target="_blank" aria-label="TikTok">
                <i class="fa-brands fa-tiktok"></i>
              </a>
            </div>
          </div>
        </div>

<!--        &lt;!&ndash; Product Column &ndash;&gt;-->
<!--        <div class="col-lg-2 col-md-6 col-6">-->
<!--          <div class="footer-links">-->
<!--            <h4>{{ 'footer.product' | translate }}</h4>-->
<!--            <ul>-->
<!--              <li><a routerLink="/solutions">{{ 'footer.product.features' | translate }}</a></li>-->
<!--              <li><a routerLink="/pricing">{{ 'footer.product.pricing' | translate }}</a></li>-->
<!--              <li><a routerLink="/solutions">{{ 'footer.product.integrations' | translate }}</a></li>-->
<!--              <li><a routerLink="/about">{{ 'footer.product.updates' | translate }}</a></li>-->
<!--            </ul>-->
<!--          </div>-->
<!--        </div>-->

        <!-- Company Column -->
        <div class="col-lg-2 col-md-6 col-6">
          <div class="footer-links">
            <h4>{{ 'footer.company' | translate }}</h4>
            <ul>
              <li><a routerLink="/about">{{ 'footer.company.aboutUs' | translate }}</a></li>
<!--              <li><a routerLink="/about">{{ 'footer.company.careers' | translate }}</a></li>-->
<!--              <li><a routerLink="/about">{{ 'footer.company.press' | translate }}</a></li>-->
              <li><a routerLink="/about">{{ 'footer.company.contact' | translate }}</a></li>
            </ul>
          </div>
        </div>

        <!-- Resources Column -->
        <div class="col-lg-2 col-md-6 col-6">
          <div class="footer-links">
            <h4>{{ 'footer.resources' | translate }}</h4>
            <ul>
              <li><a routerLink="/about">{{ 'footer.resources.helpCenter' | translate }}</a></li>
<!--              <li><a routerLink="/about">{{ 'footer.resources.blog' | translate }}</a></li>-->
<!--              <li><a routerLink="/about">{{ 'footer.resources.guides' | translate }}</a></li>-->
<!--              <li><a routerLink="/about">{{ 'footer.resources.webinars' | translate }}</a></li>-->
            </ul>
          </div>
        </div>

        <!-- Legal Column -->
        <div class="col-lg-2 col-md-6 col-6">
          <div class="footer-links">
            <h4>{{ 'footer.legal' | translate }}</h4>
            <ul>
              <li><a routerLink="/privacy-policy">{{ 'footer.legal.privacyPolicy' | translate }}</a></li>
              <li><a routerLink="/terms-of-service">{{ 'footer.legal.termsOfService' | translate }}</a></li>
              <li><a routerLink="/cookie-policy">{{ 'footer.legal.cookiePolicy' | translate }}</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="footer-bottom">
    <div class="container" style="max-width: 1200px">
      <div class="footer-bottom-content">
        <p class="copyright">&copy; {{ currentYear }} {{ 'footer.copyright' | translate }}</p>
        <p class="made-with">{{ 'footer.madeWith' | translate }} <i class="fa fa-heart"></i> {{ 'footer.forEquestrians' | translate }}</p>
      </div>
    </div>
  </div>
</footer>
